import { Day } from "../types";

export const MINUTES = 60;
export const HOURS = 60 * MINUTES;
export const DAYS = 24 * HOURS;
export const WEEKS = 7 * DAYS;

export const DAYS_OF_THE_WEEK: Day[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Species = {
  Aedes: {
    aegypti: "aegypti",
    albopictus: "albopictus",
    annulipes: "annulipes",
    cantans: "cantans",
    caspius: "caspius",
    cinereus: "cinereus",
    detritus: "detritus",
    dorsalis: "dorsalis",
    flavescens: "flavescens",
    geminus: "geminus",
    geniculatus: "geniculatus",
    japonicus: "japonicus",
    leucomelas: "leucomelas",
    punctor: "punctor",
    rusticus: "rusticus",
    sticticus: "sticticus",
    vexans: "vexans",
  },
  Anopheles: {
    claviger: "claviger",
    maculipennis: "maculipennis",
    plumbeus: "plumbeus",
  },
  Coquillettidia: {
    richiardii: "richiardii",
  },
  Culex: {
    modestus: "modestus",
    pipiens: "pipiens",
    "pipiens biotype molestus": "pipiens biotype molestus",
  },
  Culiseta: {
    fumipennis: "fumipennis",
    longiareolata: "longiareolata",
  },
};

// reshape then to be easier to use
export const SpeciesList = Object.entries(Species).reduce(
  (acc, [genus, species]) => {
    acc.push({
      genus,
      species: Object.entries(species).map(([speciesName]) => speciesName),
    });
    return acc;
  },
  [] as { genus: string; species: string[] }[],
);

export const TagColorMap: { [key: string]: string } = {
  Update: "magenta",
  Capture: "cyan",
  Motor: "green",
  Detection: "blue",
  Other: "volcano",
};
